var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"d3_root",staticClass:"stellar"}),_vm._v(" "),(_vm.chartData && (!_vm.render_info || _vm.render_info.display_extra))?_c('div',[_c('span',{staticStyle:{"color":"lightgray"}},[_vm._v("\n            Stellar\n        ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }